class VideoItem {
  constructor(elem) {
    this.elem = elem;
    this.youtubeId = elem.getAttribute('youtube-id');
    this.playerId = elem.getAttribute('player-id');
    // console.log(this.youtubeId, this.playerId);

    elem.querySelector('[js-video-item-trigger]').addEventListener('click', () => {
      this.onClicked();
    });
  }

  onClicked() {
    if (this.player) {
      // 2回目以降の再生
      this.elem.setAttribute('js-playing', 'true');
      this.elem.querySelector('[js-video-item-cover]').classList.add('twcss-hidden');
      this.elem.querySelector('[js-video-item-trigger]').classList.add('twcss-hidden');
      this.player.seekTo(0);
      this.player.playVideo();
    } else {
      // 最初の再生時にplayerを初期化
      this.player = new YT.Player(this.playerId, {
        // height: '360',
        // width: '640',
        videoId: this.youtubeId,
        playerVars: {
          autoplay: 1,
          color: 'white',
          controls: 1, // コントロール表示
          disablekb: 1, // キーボードショートカット無効
          enablejsapi: 1, // JS API有効
          fs: 0, // フルスクリーンボタン無効
          loop: 0,
          modestbranding: 1, // YouTube プレーヤーに YouTube ロゴが表示されないように??
          playsinline: 1, // iOS 上の HTML5 プレーヤーで動画をインライン再生
          rel: 0, // 関連動画無効
        },
        events: {
          onReady: (event) => {
            this.onPlayerReady(event);
          },
          onStateChange: (event) => {
            this.onPlayerStateChange(event);
          },
        },
      });
    }
  }

  onPlayerReady(event) {
    this.elem.setAttribute('js-playing', 'true');
    this.elem.querySelector('[js-video-item-cover]').classList.add('twcss-hidden');
    this.elem.querySelector('[js-video-item-trigger]').classList.add('twcss-hidden');
  }

  onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      this.elem.dispatchEvent(
        new CustomEvent('onPlayerStart', {
          detail: {
            playerId: this.playerId,
          },
        })
      );
    } else if (event.data == YT.PlayerState.ENDED) {
      this.elem.setAttribute('js-playing', 'false');
      this.elem.querySelector('[js-video-item-cover]').classList.remove('twcss-hidden');
      this.elem.querySelector('[js-video-item-trigger]').classList.remove('twcss-hidden');
    }
  }

  pause() {
    if (this.player) {
      this.player.pauseVideo();
    }
  }
}

class Video {
  constructor() {
    var tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.onYouTubeIframeAPIReady = () => {
      // console.log('onYouTubeIframeAPIReady');
      this.bindEvents();
    };
  }

  bindEvents() {
    this.videoItems = [];
    document.querySelectorAll('[js-video-item]').forEach((elem) => {
      let videoItem = new VideoItem(elem);
      this.videoItems.push(videoItem);

      elem.addEventListener('onPlayerStart', (e) => {
        // 動画再生する時は他の動画を一時停止する
        for (let i = 0; i < this.videoItems.length; i++) {
          if (this.videoItems[i].playerId != e.detail.playerId) {
            this.videoItems[i].pause();
          } else {
          }
        }
      });
    });
  }
}

let video = new Video();
